import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import { Card, CardBody } from "reactstrap";
import "./styled.css";

// services
import { postSurvey } from "../../../services/survey";
import { createEarnedPoints } from "../../../services/ranking";
// componentes
import Question1 from "./question1";
import Question2 from "./question2";
import Question3 from "./question3";
import Question4 from "./question4";
import Question5 from "./question5";
import Question6 from "./question6";
import Question7 from "./question7";
import Question8 from "./question8";
import Question9 from "./question9";
import FinalModal from "./finalModal";

export default function StefaniniEnquete1Questions(props) {
  const { t } = useContext(QuizContext);
  const { user } = props;
  // todas as questões selecionadas
  const [questionsSelected, setQuestionSelected] = useState({});
  // verificar respostas
  const [checkAnswers, setCheckAnswers] = useState(false);
  // modal de finalização
  const [modal, setModal] = useState(false);
  // erro
  const [erro, setErro] = useState(false);
  // carregando btn
  const [loading, setLoading] = useState(false);

  async function verifyAnswers() {
    setLoading(true);
    // verificar se todas foram respondidas
    if (
      !questionsSelected.question1 ||
      !questionsSelected.question2 ||
      !questionsSelected.question3 ||
      !questionsSelected.question4 ||
      !questionsSelected.question5 ||
      !questionsSelected.question6 ||
      !questionsSelected.question7 ||
      !questionsSelected.question8 ||
      !questionsSelected.question9
    ) {
      setErro(true);
      setLoading(false);
      return;
    } else setErro(false);

    // enviar dados para api
    if (user.idEvent && user.idPart) {
      const data6 = {
        eventId: user.idEvent,
        loginId: user.idPart,
        question: questionsSelected.question6.title,
        answer: questionsSelected.question6.option,
        hit: questionsSelected.question6.correct,
      };

      await postSurvey(data6).then((res) => {
        if (res.message === "created" && questionsSelected.question6.correct) {
          const dataRanking6 = {
            code: "QUIZ1QUESTION1",
            positive: true,
            log: "Acertou enquete",
          };

          createEarnedPoints(dataRanking6, user.idEvent, user.idPart);
        }
      });

      const data7 = {
        eventId: user.idEvent,
        loginId: user.idPart,
        question: questionsSelected.question7.title,
        answer: questionsSelected.question7.option,
        hit: questionsSelected.question7.correct,
      };

      await postSurvey(data7).then((res) => {
        if (res.message === "created" && questionsSelected.question7.correct) {
          const dataRanking7 = {
            code: "QUIZ1QUESTION2",
            positive: true,
            log: "Acertou enquete",
          };

          createEarnedPoints(dataRanking7, user.idEvent, user.idPart);
        }
      });

      const data8 = {
        eventId: user.idEvent,
        loginId: user.idPart,
        question: questionsSelected.question8.title,
        answer: questionsSelected.question8.option,
        hit: questionsSelected.question8.correct,
      };

      await postSurvey(data8).then((res) => {
        if (res.message === "created" && questionsSelected.question8.correct) {
          const dataRanking8 = {
            code: "QUIZ1QUESTION3",
            positive: true,
            log: "Acertou enquete",
          };

          createEarnedPoints(dataRanking8, user.idEvent, user.idPart);
        }
      });

      const data9 = {
        eventId: user.idEvent,
        loginId: user.idPart,
        question: questionsSelected.question9.title,
        answer: questionsSelected.question9.option,
        hit: questionsSelected.question9.correct,
      };

      await postSurvey(data9).then((res) => {
        if (res.message === "created" && questionsSelected.question9.correct) {
          const dataRanking9 = {
            code: "QUIZ1QUESTION4",
            positive: true,
            log: "Acertou enquete",
          };

          createEarnedPoints(dataRanking9, user.idEvent, user.idPart);
        }
      });

      const data1 = {
        eventId: user.idEvent,
        loginId: user.idPart,
        question: questionsSelected.question1.title,
        answer: questionsSelected.question1.option,
        hit: questionsSelected.question1.correct,
      };

      await postSurvey(data1).then((res) => {
        console.log("1", res);
        if (res.message === "created" && questionsSelected.question1.correct) {
          const dataRanking1 = {
            code: "QUIZ1QUESTION5",
            positive: true,
            log: "Acertou enquete",
          };

          createEarnedPoints(dataRanking1, user.idEvent, user.idPart).then(
            (res2) => {
              console.log("2", res2);
            }
          );
        }
      });

      const data2 = {
        eventId: user.idEvent,
        loginId: user.idPart,
        question: questionsSelected.question2.title,
        answer: questionsSelected.question2.option,
        hit: questionsSelected.question2.correct,
      };

      await postSurvey(data2).then((res) => {
        if (res.message === "created" && questionsSelected.question2.correct) {
          const dataRanking2 = {
            code: "QUIZ1QUESTION6",
            positive: true,
            log: "Acertou enquete",
          };

          createEarnedPoints(dataRanking2, user.idEvent, user.idPart);
        }
      });

      const data3 = {
        eventId: user.idEvent,
        loginId: user.idPart,
        question: questionsSelected.question3.title,
        answer: questionsSelected.question3.option,
        hit: questionsSelected.question3.correct,
      };

      await postSurvey(data3).then((res) => {
        if (res.message === "created" && questionsSelected.question3.correct) {
          const dataRanking3 = {
            code: "QUIZ1QUESTION7",
            positive: true,
            log: "Acertou enquete",
          };

          createEarnedPoints(dataRanking3, user.idEvent, user.idPart);
        }
      });

      const data4 = {
        eventId: user.idEvent,
        loginId: user.idPart,
        question: questionsSelected.question4.title,
        answer: questionsSelected.question4.option,
        hit: questionsSelected.question4.correct,
      };

      await postSurvey(data4).then((res) => {
        if (res.message === "created" && questionsSelected.question4.correct) {
          const dataRanking4 = {
            code: "QUIZ1QUESTION8",
            positive: true,
            log: "Acertou enquete",
          };

          createEarnedPoints(dataRanking4, user.idEvent, user.idPart);
        }
      });

      const data5 = {
        eventId: user.idEvent,
        loginId: user.idPart,
        question: questionsSelected.question5.title,
        answer: questionsSelected.question5.option,
        hit: questionsSelected.question5.correct,
      };

      await postSurvey(data5).then((res) => {
        if (res.message === "created" && questionsSelected.question5.correct) {
          const dataRanking5 = {
            code: "QUIZ1QUESTION9",
            positive: true,
            log: "Acertou enquete",
          };

          createEarnedPoints(dataRanking5, user.idEvent, user.idPart);
        }
      });
    }

    setLoading(false);

    setCheckAnswers(true);

    setModal(true);
  }
  return (
    <section className="section-ste">
      {modal && (
        <FinalModal
          isOpen={modal}
          toggle={() => setModal(!modal)}
          questions={questionsSelected}
        />
      )}

      <Card className="card-ste">
        <CardBody>
          <Question6
            setQuestionSelected={setQuestionSelected}
            checkAnswers={checkAnswers}
          />

          <Question7
            setQuestionSelected={setQuestionSelected}
            checkAnswers={checkAnswers}
          />

          <Question8
            setQuestionSelected={setQuestionSelected}
            checkAnswers={checkAnswers}
          />

          <Question9
            setQuestionSelected={setQuestionSelected}
            checkAnswers={checkAnswers}
          />

          <Question1
            setQuestionSelected={setQuestionSelected}
            checkAnswers={checkAnswers}
          />

          <Question2
            setQuestionSelected={setQuestionSelected}
            checkAnswers={checkAnswers}
          />

          <Question3
            setQuestionSelected={setQuestionSelected}
            checkAnswers={checkAnswers}
          />

          <Question4
            setQuestionSelected={setQuestionSelected}
            checkAnswers={checkAnswers}
          />

          <Question5
            setQuestionSelected={setQuestionSelected}
            checkAnswers={checkAnswers}
          />

          {erro && (
            <div style={{ textAlign: "center" }}>
              <a style={{ color: "red", fontSize: 17 }}>
                {t("Responda todas perguntas")}
              </a>
            </div>
          )}

          <a
            className={`${checkAnswers ? "btn-submit-disabled" : "btn-submit"}`}
            onClick={() => {
              if (!checkAnswers && !loading) {
                verifyAnswers();
              }
            }}
          >
            {t("Salvar respostas")}
          </a>
        </CardBody>
      </Card>
    </section>
  );
}
